import React from 'react';
import chevronLeftSmall from 'styleguide/icons/ds2/chevronleftsmall.svg';
import chevronRightSmall from 'styleguide/icons/ds2/chevronrightsmall.svg';

interface CalendarHeaderProps {
  month: number;
  year: number;
  onPrev: () => void;
  onNext: () => void;
 openBehaviour?: 'calendarView' | 'iconView' // Optional prop to control open behavior
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({ month, year, onPrev, onNext,openBehaviour }) => (
  <div className="cal-header flex justify-between items-center mb-2">
    <button type="button" onClick={onPrev} aria-label="Previous month" className="p-1">
      <img src={chevronLeftSmall} alt="Previous month" className="w-4 h-4" />
    </button>
    <span className={openBehaviour === 'calendarView' ? 'h2' : "font-bold text-2xl"}>{new Date(year, month).toLocaleString(undefined, { month: 'long' })} {year}</span>
    <button type="button" onClick={onNext} aria-label="Next month" className="p-1">
      <img src={chevronRightSmall} alt="Next month" className="w-4 h-4" />
    </button>
  </div>
);

export default CalendarHeader;
